export const DiscordIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
            fill="currentColor"
            d="M20.32 4.37A19.79 19.79 0 0 0 15.44 2.85a.07.07 0 0 0-.08.04c-.21.37-.44.86-.61 1.25a18.27 18.27 0 0 0-5.49 0c-.17-.39-.4-.88-.62-1.25a.08.08 0 0 0-.08-.04A19.74 19.74 0 0 0 3.68 4.37a.07.07 0 0 0-.03.03C.53 9.05-.32 13.58.1 18.06c0 .03.01.04.03.06a19.9 19.9 0 0 0 5.99 3.03.08.08 0 0 0 .08-.03c.36-.5.77-1.16 1.23-1.99a.08.08 0 0 0-.04-.11c-.64-.24-1.27-.54-1.87-.89a.08.08 0 0 1-.01-.13c.12-.1.25-.2.37-.29a.07.07 0 0 1 .08-.01c3.93 1.79 8.18 1.79 12.06 0a.07.07 0 0 1 .08.01c.12.1.25.2.37.29a.08.08 0 0 1-.01.13c-.6.35-1.23.65-1.87.89a.08.08 0 0 0-.04.11c.36.7.77 1.36 1.23 1.99a.08.08 0 0 0 .08.03 19.84 19.84 0 0 0 6-3.03.08.08 0 0 0 .03-.05c.5-5.18-.84-9.67-3.55-13.66a.06.06 0 0 0-.03-.03ZM8.02 15.33c-1.18 0-2.16-1.08-2.16-2.42s.96-2.42 2.16-2.42c1.21 0 2.18 1.1 2.16 2.42 0 1.33-.95 2.42-2.16 2.42Zm7.98 0c-1.18 0-2.16-1.08-2.16-2.42s.96-2.42 2.16-2.42c1.21 0 2.18 1.1 2.16 2.42 0 1.33-.95 2.42-2.16 2.42Z"
        />
    </svg>
);

export const TikTokIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
            fill="currentColor"
            d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.76-.08 1.4-.54 2.79-1.35 3.99-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.06.02-12.09Z"
        />
    </svg>
);

export const InstagramIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
            fill="currentColor"
            d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm5 3.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 0 1 12 7.5Zm0 2A2.5 2.5 0 1 0 14.5 12 2.5 2.5 0 0 0 12 9.5Zm5.25-3.25a1 1 0 1 1-1 1 1 1 0 0 1 1-1Z"
        />
    </svg>
);

export const YouTubeIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
            fill="currentColor"
            d="M21.8 8a2.75 2.75 0 0 0-1.94-1.95C18.2 5.5 12 5.5 12 5.5s-6.2 0-7.86.55A2.75 2.75 0 0 0 2.2 8C1.65 9.66 1.5 12 1.5 12s.15 2.34.7 4a2.75 2.75 0 0 0 1.94 1.95c1.66.55 7.86.55 7.86.55s6.2 0 7.86-.55A2.75 2.75 0 0 0 21.8 16c.55-1.66.7-4 .7-4s-.15-2.34-.7-4ZM10 15.5v-7l6 3.5-6 3.5Z"
        />
    </svg>
);

export const EmailIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect
            x="3.5"
            y="5.5"
            width="17"
            height="13"
            rx="1"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
        />
        <path
            d="m4.5 7 7.5 5.5L19.5 7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);